import React from 'react';

import Modal from '~/atomic/molecula/Modal';
import { registerAssetBalance } from '~/feature/finance/accountReplenishment/accountReplenishment.data';
import { accountReplenishmentSelector } from '~/feature/finance/accountReplenishment/accountReplenishment.selector';
import { useAppDispatch, useAppSelector } from '~/store';

import { AccountReplenishmentChooseAmount } from './AccountReplenishment';
import { accountReplenishmentActions } from './accountReplenishment.slice';

export const AccountReplenishmentModal = () => {
  const dispatch = useAppDispatch();
  const { isOpenModal } = useAppSelector(accountReplenishmentSelector);

  const closeModal = () => {
    dispatch(accountReplenishmentActions.setIsOpenModal(false));
  };

  return (
    <Modal
      open={isOpenModal}
      onCancel={closeModal}
    >
      <AccountReplenishmentChooseAmount
        registerAssetBalance={({
          methodPayment, bankCardId, amount,
        }) => {
          return dispatch(registerAssetBalance({
            methodPayment,
            bankCardId,
            amount,
          }));
        }}
      />
    </Modal>
  );
};
